import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteMessageTypeModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  scannedCount: number = 0;
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteMessageTypeModel {
    const t = new DeleteMessageTypeModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetMessageType && data.data.GetMessageType.Delete) {
      this.deleted = data.data.GetMessageType.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetMessageType or data.data.GetMessageType.Delete');
    }
  }
}